import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import config from '../../../config';
import { appendHoneyGuide } from '../../../lib/utils';
import { TransportationSearchForm, useTransportationJson } from '../Common';
import { WhitePanel, Page, CardsSlider, LodgeCard, TrekCard, FullReview, SideReview, UVP, FeaturedTransportSlider, FAQ } from '../../../components';
import reviews from './transportationReviews.json';
// import CoronaVirusNotice from './CoronaVirusNotice';
import uvpData from './uvpData';

const title = 'Car Rental and Bus Booking for Everest, Annapurna and Pokhara.';
const subText ='With 24/7 WhatsApp Support.';
const bgImages = 'url(https://s3.amazonaws.com/honeyguide/assets/lodge-bg.jpg)';

export default function TransportationSearchScreen() {
  useTransportationJson();

  return (
    <Page title={appendHoneyGuide(title)}>
      <Container fluid={true} className="mt--1">
      <Row className="flight-search transportation">
        <div className="container-bg" style={{ backgroundImage: bgImages }}>
          <Container className="full-height flex-with-center flex-column">
            <div className="search-panel">
              <h1 className="ft-page-title">{title}</h1>
              <p className="sub">{subText}</p>
              <div className="SearchForm">
                <TransportationSearchForm />
              </div>
            </div>
          </Container>
          {/* <CoronaVirusNotice /> */}
        </div>
      </Row>
      </Container>
      <Container>
        <Row>
          {/* <CoronaVirusNotice onMobile/> */}
          <UVP data={uvpData} />
        </Row>
        <Row className="flight-search transportation">
        <Col xs={{size: 12, order:2}} lg={{size: 8, order: 1}}>
            <WhitePanel>
              <Message />
            </WhitePanel>
            <FAQ />
            <FeaturedTransportSlider dataKey="KTMRHP"/>
            <CardsSlider
              title="Featured Lodges"
              endpoint="lodgings/lodges?is_featured=1"
              Card={LodgeCard}
              showNoOfCards="3"
            />
            <CardsSlider
              title="Check out these Itineraries for Recommended Stops:"
              endpoint="trips/treks?is_featured=1"
              Card={TrekCard}
              showNoOfCards="3"
            />
            <FullReview reviews={reviews} type="flight" sectionId="fullReviewsSection"/>
            <FullReview reviews={reviews} type="flight" isMobile sectionId="fullReviewsSection"/>
          </Col>
          <Col xs={{size: 12, order: 1}} lg={{size: 4, order: 2}}>
            <SideReview reviews={reviews} type="flight" fullReviewsSectionId="#fullReviewsSection"/>
            <SideReview reviews={reviews} type="flight" fullReviewsSectionId="#fullReviewsSection" isMobile/>
          </Col>
        </Row>
      </Container>
    </Page>
  );
}

const Message = () => (
  <React.Fragment>
    <h2>Important Notice</h2>
    <p>
      If you’re looking to book transport for other places that aren’t available on the
      list, please send an enquiry to{' '}
      <a href={`mailto:${config.honeyguideEmail}`} style={{ color: '#00C0FF' }}>
        {config.honeyguideEmail}
      </a>{' '}
      or call / whatsapp us at{' '}
      <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} style={{ color: '#00C0FF' }}>
        {config.honeyguidePhoneNumber}
      </a>
    </p>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationSearch/TransportationSearchScreen.js